import { useEffect, useRef } from 'react';
import { Close } from '@mui/icons-material';
import styles from './MapExpandModal.module.css';
import { BrazilMapGL } from '../BrazilMap/BrazilMapGL';
import type { RegionDTO } from '../../../types/parameters.types';

interface MapExpandModalProps {
	region: RegionDTO;
	onClose: () => void;
}

export const MapExpandModal = ({ region, onClose }: MapExpandModalProps) => {
	const overlayRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleKey = (e: KeyboardEvent) => {
			if (e.key === 'Escape') onClose();
		};
		document.addEventListener('keydown', handleKey);
		return () => document.removeEventListener('keydown', handleKey);
	}, [onClose]);

	useEffect(() => {
		document.body.style.overflow = 'hidden';
		return () => {
			document.body.style.overflow = '';
		};
	}, []);

	const createdDate = new Date(region.createdAt).toLocaleDateString('pt-BR', {
		day: '2-digit',
		month: 'short',
		year: 'numeric',
	});

	return (
		<div
			ref={overlayRef}
			className={styles.overlay}
			onClick={(e) => e.target === overlayRef.current && onClose()}
		>
			<div className={styles.modal}>
				<div className={styles.header}>
					<div className={styles.titleGroup}>
						<span className={styles.title}>{region.name}</span>
						<span className={styles.subtitle}>
							Mapa da Região · Criado em {createdDate}
						</span>
					</div>
					<button className={styles.closeBtn} onClick={onClose} aria-label="Fechar mapa">
						<Close sx={{ fontSize: '1.25rem' }} />
					</button>
				</div>
				<div className={styles.mapContainer}>
					<BrazilMapGL selectedStateCodes={region.stateCodes} interactive showLabels />
				</div>
			</div>
		</div>
	);
};
